// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import FormField from "components/FormField";

function AgeGroupsForm({ formData }: any): JSX.Element {
  const { formField, values } = formData;
  const {
    ageIntervalStart1,
    ageIntervalStart2,
    ageIntervalStart3,
    ageIntervalStart4,
    ageIntervalMid1,
    ageIntervalMid2,
    ageIntervalMid3,
    ageIntervalMid4,
  } = formField;

  return (
    <MDBox>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h6">Age Interval Starts:</MDTypography>
        </Grid>
        <Grid item xs={3}>
          <FormField
            disabled={true}
            type={ageIntervalStart1.type}
            label={ageIntervalStart1.label}
            name={ageIntervalStart1.name}
            value={values.ageIntervalStart1}
            placeholder={ageIntervalStart1.placeholder}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField
            disabled={true}
            type={ageIntervalStart2.type}
            label={ageIntervalStart2.label}
            name={ageIntervalStart2.name}
            value={values.ageIntervalStart2}
            placeholder={ageIntervalStart2.placeholder}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField
            disabled={true}
            type={ageIntervalStart3.type}
            label={ageIntervalStart3.label}
            name={ageIntervalStart3.name}
            value={values.ageIntervalStart3}
            placeholder={ageIntervalStart3.placeholder}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField
            disabled={true}
            type={ageIntervalStart4.type}
            label={ageIntervalStart4.label}
            name={ageIntervalStart4.name}
            value={values.ageIntervalStart4}
            placeholder={ageIntervalStart4.placeholder}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h6">Age Interval Middles:</MDTypography>
        </Grid>
        <Grid item xs={3}>
          <FormField
            disabled={true}
            type={ageIntervalMid1.type}
            label={ageIntervalMid1.label}
            name={ageIntervalMid1.name}
            value={values.ageIntervalMid1}
            placeholder={ageIntervalMid1.placeholder}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField
            disabled={true}
            type={ageIntervalMid2.type}
            label={ageIntervalMid2.label}
            name={ageIntervalMid2.name}
            value={values.ageIntervalMid2}
            placeholder={ageIntervalMid2.placeholder}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField
            disabled={true}
            type={ageIntervalMid3.type}
            label={ageIntervalMid3.label}
            name={ageIntervalMid3.name}
            value={values.ageIntervalMid3}
            placeholder={ageIntervalMid3.placeholder}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField
            disabled={true}
            type={ageIntervalMid4.type}
            label={ageIntervalMid4.label}
            name={ageIntervalMid4.name}
            value={values.ageIntervalMid4}
            placeholder={ageIntervalMid4.placeholder}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default AgeGroupsForm;
